
import { fromContinuations } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Async.js";
import { Exception } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { PredefinedDialogState, Msg, State } from "./Types.js";
import { getPredefinedProcedureTemplates, getProcedureTemplates } from "../../Requests/ProcedureTemplate.js";
import { defaultArg, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_OfAsyncWith_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { AsyncHelpers_start } from "../../fable_modules/Fable.Elmish.5.0.2/prelude.fs.js";
import { LoadPredefinedProcedureTemplatesRequestDto_$reflection, LoadPredefinedProcedureTemplatesResultDto_$reflection, LoadPredefinedProcedureTemplatesRequestDto, ProcedureTemplateImportRequestDto_$reflection, ProcedureTemplateImportResultDto_$reflection, ProcedureTemplateImportRequestDto } from "../../Shared/ProcedureTemplateTransfer.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { isEmpty, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

function readFileAsText(file) {
    return fromContinuations((tupledArg) => {
        const reader = new FileReader();
        reader.onload = ((_arg_1) => {
            tupledArg[0](reader.result);
        });
        reader.onerror = ((_arg_2) => {
            tupledArg[1](new Exception("Failed to read file"));
        });
        reader.readAsText(file);
    });
}

export function init() {
    return [new State(new RequestedValue$1(0, []), undefined, undefined, FormState_get_empty()), getProcedureTemplates((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(11, [Item_1])))];
}

function withPredefinedDialog(state, update_1) {
    return new State(state.ProcedureTemplates, state.ImportResult, map(update_1, state.PredefinedDialog), state.FormState);
}

export function update(msg, state) {
    let dto, dto_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.ProcedureTemplates, state.ImportResult, state.PredefinedDialog, FormState__startLoading(state.FormState)), Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, readFileAsText, msg.fields[0], (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(11, [Item_1])))];
        case 2:
            return [state, (dto = (new ProcedureTemplateImportRequestDto(msg.fields[0])), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ProcedureTemplateImportResultDto_$reflection()));
                }, refreshOn)))(true);
            })), ["/api/procedure-templates/import", toString(0, Auto_generateBoxedEncoder_437914C6(ProcedureTemplateImportRequestDto_$reflection(), undefined, undefined, undefined)(dto))], (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(11, [Item_3]))))];
        case 3: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                const validationResponse = response_2.fields[0];
                return [new State(state.ProcedureTemplates, state.ImportResult, state.PredefinedDialog, FormState__setValidationResponse_5219762A(state.FormState, validationResponse)), Cmd_errorToast(defaultArg(validationResponse.GlobalValidationMessage, "validation.toast"))];
            }
            else {
                return [new State(state.ProcedureTemplates, response_2.fields[0], state.PredefinedDialog, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("procedure_template.import.success"), getProcedureTemplates((Item_4) => (new Msg(0, [Item_4])), (Item_5) => (new Msg(11, [Item_5])))]))];
            }
        }
        case 4:
            return [new State(state.ProcedureTemplates, undefined, state.PredefinedDialog, state.FormState), Cmd_none()];
        case 5:
            return [new State(state.ProcedureTemplates, state.ImportResult, new PredefinedDialogState(new RequestedValue$1(0, []), undefined), state.FormState), getPredefinedProcedureTemplates((Item_6) => (new Msg(6, [Item_6])), (Item_7) => (new Msg(11, [Item_7])))];
        case 6:
            return [withPredefinedDialog(state, (dialog) => (new PredefinedDialogState(new RequestedValue$1(1, [msg.fields[0]]), dialog.SelectedKey))), Cmd_none()];
        case 7:
            return [withPredefinedDialog(state, (dialog_1) => (new PredefinedDialogState(dialog_1.Templates, msg.fields[0]))), Cmd_none()];
        case 8: {
            const matchValue = state.PredefinedDialog;
            let matchResult, key_1;
            if (matchValue != null) {
                if (matchValue.SelectedKey != null) {
                    matchResult = 0;
                    key_1 = matchValue.SelectedKey;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.ProcedureTemplates, state.ImportResult, state.PredefinedDialog, FormState__startLoading(state.FormState)), (dto_1 = (new LoadPredefinedProcedureTemplatesRequestDto(singleton(key_1))), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_3) => {
                            const pr_1 = response_3.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), LoadPredefinedProcedureTemplatesResultDto_$reflection()));
                        }, refreshOn_1)))(true);
                    })), ["/api/procedure-templates/predefined", toString(0, Auto_generateBoxedEncoder_437914C6(LoadPredefinedProcedureTemplatesRequestDto_$reflection(), undefined, undefined, undefined)(dto_1))], (Item_8) => (new Msg(9, [Item_8])), (Item_9) => (new Msg(11, [Item_9]))))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 9: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                const validationResponse_1 = response_5.fields[0];
                return [new State(state.ProcedureTemplates, state.ImportResult, state.PredefinedDialog, FormState__setValidationResponse_5219762A(state.FormState, validationResponse_1)), Cmd_errorToast(defaultArg(validationResponse_1.GlobalValidationMessage, "validation.toast"))];
            }
            else {
                return [new State(state.ProcedureTemplates, state.ImportResult, undefined, FormState_get_empty()), Cmd_batch(toList(delay(() => append(!isEmpty(response_5.fields[0].Created) ? singleton_1(Cmd_successToast("procedure_template.predefined.success")) : empty(), delay(() => singleton_1(getProcedureTemplates((Item_10) => (new Msg(0, [Item_10])), (Item_11) => (new Msg(11, [Item_11])))))))))];
            }
        }
        case 10:
            return [new State(state.ProcedureTemplates, state.ImportResult, undefined, state.FormState), Cmd_none()];
        case 11:
            return [new State(state.ProcedureTemplates, state.ImportResult, undefined, FormState_get_empty()), Cmd_errorToast("general.error")];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.ImportResult, state.PredefinedDialog, state.FormState), Cmd_none()];
    }
}

